import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import DispatchingRuleForm from './DispatchingRuleForm'
import {
  createDispatchingRuleAction,
  updateDispatchingRuleAction
} from '@/redux/order/dispatcherSlice'

class DispatchingRuleModal extends React.Component {
  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  handleOk = async (formRef) => {
    const { baseProps } = this.props
    const { editingRule, onSuccess } = baseProps || {}

    try {
      // 获取表单值
      const values = await formRef.current.validateFields()

      // 格式化数据
      const formData = {
        ruleName: values.ruleName,
        serviceType: values.serviceType,
        radius: values.radius || 5,
        enabled: values.enabled !== undefined ? values.enabled : true,
        matchConditions: {
          includeUpcoming: values.includeUpcoming !== undefined ? values.includeUpcoming : true,
          minRating: values.minRating,
          maxDistance: values.maxDistance
        },
        pushSettings: {
          pushCount: values.pushCount || 3,
          timeout: values.timeout || 30
        }
      }

      // 调用保存接口
      const dispatch = this.props.dispatch
      if (editingRule) {
        // 更新规则
        await dispatch(updateDispatchingRuleAction({
          ruleId: editingRule.id,
          data: formData
        })).unwrap()
        message.success('更新成功')
      } else {
        // 创建规则
        await dispatch(createDispatchingRuleAction(formData)).unwrap()
        message.success('创建成功')
      }

      // 调用成功回调
      if (onSuccess) {
        onSuccess()
      }

      return true // 返回 true 关闭弹窗
    } catch (error) {
      console.error('保存规则失败:', error)
      if (error && typeof error === 'string') {
        message.error(error)
      } else if (error?.errorFields) {
        // 表单验证错误，不显示消息
      } else {
        message.error('操作失败')
      }
      return false // 返回 false 不关闭弹窗
    }
  }

  handleCancel = () => {
    const { baseProps } = this.props
    const { onCancel } = baseProps || {}
    if (onCancel) {
      onCancel()
    }
  }

  render() {
    const { children, baseProps, title } = this.props
    const { editingRule } = baseProps || {}
    const isEdit = !!editingRule

    const baseComponent = (
      <DispatchingRuleForm
        editingRule={editingRule}
        dispatch={this.props.dispatch}
      />
    )

    return (
      <WrappedModal
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title || (isEdit ? '编辑派单规则' : '新建派单规则')}
        width={600}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        centerTitle
        className="center-title-modal"
      />
    )
  }
}

// 使用函数组件作为wrapper来使用React Redux Hooks
const DispatchingRuleModalWrapper = (props) => {
  const dispatch = useDispatch()

  const enhancedProps = {
    dispatch,
    baseProps: {
      ...props.baseProps
    },
    ...props
  }

  return <DispatchingRuleModal {...enhancedProps} />
}

export default DispatchingRuleModalWrapper

